exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-5d4c064b] {\n  margin-bottom: 0;\n}\nbutton[type=submit][data-v-5d4c064b] {\n  cursor: pointer;\n}", ""]);

// exports
